// ════════════════════════════════════════════════════════════════════════════
//  ManDana — what ships with the app, made findable
//  ---------------------------------------------------------------------------
//  Six projects, one pursuit and ten domains are defined in CODE. That is what
//  makes them dependable — a built-in that a bad merge could corrupt or lose is
//  not built in — and for a long time it also meant they did not exist as
//  documents at all.
//
//  Which made them UNFINDABLE. The FTS5 index is built over documents, so
//  typing "Prayer" into the Finder returned nothing while a project called
//  Prayers sat in the Workshop one window away. Found by driving the app on
//  2026-08-20, not by a test, which is the usual way.
//
//  THE FIX IS ONE FIELD, NOT A MIGRATION. Every built-in already has a home
//  document — `md:project:<id>`, `md:pursuit:<id>`, `md:domain:<id>` — which
//  already syncs and already merges one field at a time. Its NAME joins that
//  document. The definition in code stays exactly where it was and stays the
//  default; the document lays a name over it, the same way it already lays over
//  a status or a target.
//
//  WHAT THIS FILE IS NOT ALLOWED TO DO is write to `md:projects` or
//  `md:pursuits`. Both index documents are filtered on the way in by a rule that
//  rejects any row carrying a built-in id — "never let a stored row shadow a
//  built-in" — so a device on an older bundle would strip whatever was
//  materialised there and write the stripped version straight back. The two
//  devices would then fight, silently and forever, over a document neither
//  person ever touched. Every family below writes ONE document per built-in and
//  no shared list, and that is the whole safety argument.
//
//  IT IS A COORDINATOR AND NOT AN AUTHORITY. Each family owns its own built-ins
//  and its own storage key; this file only knows the order to ask in and how to
//  add up the answers. A family that has not loaded is skipped rather than
//  crashed on, exactly as md-organizer-door.ts treats the surfaces behind it.
// ════════════════════════════════════════════════════════════════════════════
(function (g: any) {
  'use strict';

  /* In the order a person meets them: the part of life, the pursuit inside it,
     the projects under that. Nothing depends on the order — every one of these
     is independent — but a log read in this order reads like the app. */
  const FAMILIES = [
    'mdDomainMaterialiseBuiltins',
    'mdPursuitMaterialiseBuiltins',
    'mdProjectMaterialiseBuiltins',
  ];

  /** Give everything the app ships a document to be found by. Returns how many
      documents had to be written, which is greater than zero exactly once per
      account and zero on every boot after that — the cheapest possible proof
      that this is not doing work on a settled device. Safe to call at any time
      and safe to call twice. */
  function mdBuiltinsMaterialise(): number {
    let wrote = 0;
    for (const name of FAMILIES) {
      if (typeof g[name] !== 'function') continue;
      /* A family that throws must not stop the others, and must never stop a
         boot: being unfindable is a poor search result, not a lost account. */
      try { wrote += g[name]() || 0; } catch (e) {}
    }
    return wrote;
  }

  g.mdBuiltinsMaterialise = mdBuiltinsMaterialise;

  // CommonJS escape hatch, following md-record.ts and md-organizer-door.ts.
  const mod = (globalThis as { module?: { exports?: unknown } }).module;
  if (mod && mod.exports) mod.exports = { mdBuiltinsMaterialise };
})(typeof window !== 'undefined' ? window : globalThis);
